// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__YYSwq","footer":"ChangeClinic_footer__1gAYf"};